import { overrideIfUndefined } from '../../util/data';
import { measureTextWidth, normalizeToArray } from '../../util/utils';
import { Option } from '../../core/option';
import type StandardChart from '../../core/StandardChart';

// 处理x轴标签显示个数
function parseXAxisLabelCount(chart) {
  const { _option } = chart.getModel();
  const xAxisArr = normalizeToArray(_option.xAxis);
  const eCharts = chart.getECharts();
  xAxisArr.forEach((el, i) => {
    el.axisLabel = overrideIfUndefined(el.axisLabel, {});
    if (el.axisLabel.dvLayout !== undefined) {
      const splitNumber = el.axisLabel.dvLayout - 1;
      el.axisLabel.interval = (index: number) => {
        const ecModel = eCharts.getModel();
        const axisModel = ecModel.getComponent('xAxis', i);
        let data = el.data;
        // 判断xAxis配置里有无data，若无，从对应series里取数据
        if (el.data === undefined) {
          const targetSeries = _option.series.find(item => {
            const xAxisIndex = item.xAxisWidth || 0;
            return xAxisIndex === i;
          });
          if (targetSeries) {
            data = targetSeries.data;
          }
        }
        let start = 0;
        let end = data.length - 1;
        const dataZoomModel = ecModel.getComponent('dataZoom');
        // 考虑到dataZoom变化的场景，从dataZoom的model里取开始索引和结束索引
        if (dataZoomModel) {
          const startValue = dataZoomModel.option.startValue;
          const endValue = dataZoomModel.option.endValue;
          start = data.findIndex((_, index) => index === startValue);
          end = data.findIndex((_, index) => index === endValue);
          if (startValue < 0) {
            start = 0;
          }
          if (endValue > data.length - 1) {
            end = data.length - 1;
          }
        }

        // 如果x轴标签触发隐藏的上限设置为‘auto’
        if (el.axisLabel.dvLayoutTakeEffectGreaterThan === 'auto') {
          // 则根据axis对象内部计算类目轴标签的自动间隔数判定是否需要触发标签隐藏：
          // 计算的自动间隔为零 则表示所有标签均不重叠， 不需要隐藏标签， 全部显示
          if (axisModel.axis.calculateCategoryInterval() < 1) {
            return true;
          }
        } 
        // 如果x轴标签触发隐藏的上限设置为具体数值， 数据个数未超过阈值则都可显示
        else if (end - start < el.axisLabel.dvLayoutTakeEffectGreaterThan) {
          return true;
        }
        
        // 计算出数据间隔，从而确定哪些数据可以显示
        const interval = Math.floor((end - start) / splitNumber);
        const tickIndexArr = [start];
        for (let i = 1; i < el.axisLabel.dvLayout - 1; i++) {
          tickIndexArr.push(start + i * interval);
        }
        tickIndexArr.push(end);
        return tickIndexArr.includes(index);
      };
    }
  });
}

function parse(option: Option, index: number, chart: StandardChart) {
  parseXAxisLabelCount(chart);
}

export default {
  type: 'xAxis',
  parse
};
